import { MessageCircle, Users, Coins } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [MessageCircle, Users, Coins];

const PartnerHowItWorks = () => {
  const { t, tObject } = useLanguage();
  const steps = tObject<Array<{ title: string; description: string }>>("partnerPage.steps");

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("partnerPage.howItWorksTitle")}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t("partnerPage.howItWorksDescription")}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const Icon = iconMap[index] || MessageCircle;
            return (
              <Card key={index} className="relative border-border/50 hover:shadow-lg transition-shadow">
                <div className="absolute -top-4 left-6 w-10 h-10 bg-accent text-accent-foreground rounded-full flex items-center justify-center font-bold text-lg">
                  {index + 1}
                </div>
                <CardContent className="pt-10 pb-6 px-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-2">{step.title}</h3>
                  <p className="text-muted-foreground">{step.description}</p>
                </CardContent>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-border z-10" />
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartnerHowItWorks;
